import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const numberFieldDefaultVariants = {
  "size": "md"
}
const numberFieldCompoundVariants = []

const numberFieldSlotNames = [
  [
    "root",
    "numberField__root"
  ],
  [
    "group",
    "numberField__group"
  ],
  [
    "stepper",
    "numberField__stepper"
  ],
  [
    "stepperButton",
    "numberField__stepperButton"
  ]
]
const numberFieldSlotFns = /* @__PURE__ */ numberFieldSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, numberFieldDefaultVariants, getSlotCompoundVariant(numberFieldCompoundVariants, slotName))])

const numberFieldFn = memo((props = {}) => {
  return Object.fromEntries(numberFieldSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const numberFieldVariantKeys = [
  "size"
]
const getVariantProps = (variants) => ({ ...numberFieldDefaultVariants, ...compact(variants) })

export const numberField = /* @__PURE__ */ Object.assign(numberFieldFn, {
  __recipe__: false,
  __name__: 'numberField',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: numberFieldVariantKeys,
  variantMap: {
  "size": [
    "lg",
    "md",
    "sm"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, numberFieldVariantKeys)
  },
  getVariantProps
})